import { Injectable } from '@angular/core';
import { ApiEnvironmentService } from '../api-environment.service';
import { ApiMethodConstants, LocationsRequest } from '../common';

@Injectable()
export class ApiBuilder {
  constructor(private apiService: ApiEnvironmentService) {}
  public buildUrl(request: LocationsRequest, apiMethod: string): string {
    const apiBaseHref = this.apiService.getApiBaseHref();
    let url = `${apiBaseHref}/${apiMethod}/find?lon=${request.lon}&lat=${request.lat}&radius=${request.radius}`;
    if (request.heathCenter) {
      url = `${url}&healthCenter=${request.heathCenter}`;
    }
    if (apiMethod === ApiMethodConstants.Opo) {
      const organList = [];
      if (request.checkBoxData) {
        let allSelected = false;
        for (const cb of request.checkBoxData) {
          if (cb.name !== 'all' && cb.selected && !allSelected)
            organList.push(cb.value);
          else if (cb.name === 'all')
            allSelected = cb.selected;
        }

        if (organList.length || allSelected) {
          url = `${url}&includeOpos=true&includeOtcs=false`;
          url = `${url}&organList=${organList.join()}`;
        }
      }
    }
    return url;
  }
}
